<template>
    <div class="stepper mt-0 ml-3">
        <div class="step" v-for="(step, index) in steps" :key="index" :class="index === 0 ? 'stepper-view' : ''">
            <div class="step-circle" :class="getStepperCircleStatus(index)">
                <span v-if="index < currentStep" class="step-checkmark"><font-awesome-icon icon="check"
                        class="step-checkmark" /></span>
                <span v-if="index >= currentStep && index !== 4 " class="step-blackdot">{{ index + 1 }}</span>
                <span v-if="index >= currentStep && index === 4 " class="step-blackdot">{{ 4 }}</span>
            </div>
            <div class="step-label" :class="getStepperLabelStatus(index)"
                :style="{ marginLeft: index === 0 ? '50px' : index === 3 ? '65px' : index === 2 ? '35px' : '75px' }">
                {{ step }}
            </div>
            <div class="step-line" v-if="index < steps.length - 1"
                :class="{ active: index < currentStep, inactive: index > currentStep, completed: index < currentStep }">
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        currentStep: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            steps: ['Start verification', 'Download Nametag App', 'Get QR Code', 'Complete verification'],
            errorText: ""
        };
    },
    methods: {
        getStepperCircleStatus(index) {
            if (index < this.currentStep) return 'completed';
            if (index === this.currentStep) {
                return 'active';
            }
            return 'inactive';
        },
        getStepperLabelStatus(index) {
            if (index < this.currentStep) return 'completed';
            if (index === this.currentStep) {
                return 'active';
            }
            return 'inactive';
        }
    }
};
</script>

<style scoped>
.stepper {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    width: 90%;
    margin: 20px 0;
    max-width: 1200px;
}

.step {
    display: flex;
    align-items: center;
    flex-direction: column;
    flex-grow: 1;
    position: relative;
}

.stepper-view {
    margin-left: -60px;
}

.step-circle {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    border: 2px solid #ccc;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #f0ebeb;
    position: relative;
    z-index: 1;
}

.step-circle.inactive {
    font-weight: 100;
    color: gray;
}

.step-circle.error {
    font-weight: bolder;
    color: red;
    border-color: red;
    background-color: white;
}

.step-circle.active {
    border-color: black;
    background-color: white;
}

.step-circle.completed {
    background-color: #2BC275;
    border-color: #2BC275;
}

.step-checkmark {
    font-size: 14px;
    color: black;
}

.step-blackdot {
    display: block;
    font-weight: bolder;
    font-size: 14px;
}

.step-label {
    margin-top: 14px;
    text-align: center;
    color: #ccc;
    font-weight: normal;
    position: absolute;
    font-size: 14px;
    top: 18px;
    white-space: nowrap;
    left: 50%;
    transform: translateX(-50%);
    color: gray;
}

.step-label.active {
    font-weight: bold;
    color: black;
}

.step-label.error {
    color: red;
}

.step-label.completed {
    color: black;
}

.step-line {
    height: 2px;
    flex-grow: 1;
    background-color: #ccc;
    position: absolute;
    top: 15px;
    left: calc(50% + 12px);
    right: calc(-50% - 12px);
    z-index: 0;
}
.step-line.active {
    background-color: #2BC275;
    height: 3px;
}

@media ((min-width: 700px) and (max-width: 900px)) {
    .step-label {
        margin-left: 0px !important;
    }

    .stepper {
        width: 100%;
    }
}

@media (max-width: 700px) {
    .stepper {
        width: 100%;
        margin-bottom: 0px !important;
        margin-left: 0px !important;
    }

    .step-circle {
        margin-right: 10px;
        margin-left: 0px !important;
    }

    .step-label {
        display: none;
    }

    .step-circle.completed {
        display: block;
    }

    .step-circle.active {
        display: block;
    }

    .step-checkmark {
        margin: 6px 3px;
    }

    .step-blackdot {
        width: inherit;
        margin-left: 10px;
        margin-top: 3px;
    }

    .step-line {
        left: calc(50% + 6px);
        right: calc(-50% - 6px);
    }
    .stepper-view {
        margin-left: 0px;
    }
}
</style>
